import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useMercenary } from '../../../contexts/MercenaryContext';
import './AdventureList.css';

interface Adventure {
  id: number;
  title: string;
  rarity: string;
  starting_chapter_id: number;
  current_chapter_id?: number;
}

const AdventureList: React.FC = () => {
  const [ongoingAdventure, setOngoingAdventure] = useState<Adventure | null>(null);
  const { mercenary } = useMercenary();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAdventures = async () => {
      try {
        if (mercenary) {
          const ongoingResponse = await axios.get(`/api/adventures/ongoing/${mercenary.id}`);
          if (ongoingResponse.data) {
            setOngoingAdventure(ongoingResponse.data);
          }
        }
      } catch (error) {
        console.error('Error fetching adventures:', error);
      }
    };

    fetchAdventures();
  }, [mercenary]);

  useEffect(() => {
    // Redirect to ongoing adventure if it exists
    if (ongoingAdventure && ongoingAdventure.current_chapter_id) {
      navigate(`/adventure/${ongoingAdventure.id}/chapter/${ongoingAdventure.current_chapter_id}`);
    }
  }, [ongoingAdventure, navigate]);

  const handleRandomAdventure = async () => {
    try {
      const response = await axios.get('/api/adventures/random');
      const adventure = response.data;

      if (mercenary) {
        await axios.post('/api/adventures/start', {
          mercenary_id: mercenary.id,
          adventure_id: adventure.id
        });
        navigate(`/adventure/${adventure.id}/chapter/${adventure.starting_chapter_id}`);
      } else {
        console.error('No mercenary found. Please select a mercenary to start an adventure.');
      }
    } catch (error) {
      console.error('Error starting random adventure:', error);
    }
  };

  return (
    <div className="adventure-list">
      <h2>Take a Break from the Arena and Embark on an Adventure</h2>
      <p className="intro-text">
        The city of Njordheim beckons to those bold enough to step away from the blood-stained sands of the arena. 
        Beyond the clash of steel and cries of battle lies a world of ancient secrets, hidden relics, and timeless lore waiting to be unearthed. 
        Will you dare to traverse forgotten ruins, delve into mysterious forests, or confront the whispers of spirits long lost to legend? 
        Arm yourself with courage, for every adventure brings with it a tale worthy of song at Stonebolt's Tavern and a chance at unimaginable treasure. 
        Step forward, brave mercenary, and let the path unveil its mysteries.
      </p>

      {ongoingAdventure ? (
        <p className="info-text">
          You are currently on an adventure titled <strong>{ongoingAdventure.title}</strong>. Redirecting you now...
        </p>
      ) : (
        <button onClick={handleRandomAdventure} className="start-adventure-button">
          Embark on a New Adventure!
        </button>
      )}
    </div>
  );
};

export default AdventureList;
